import React from 'react'
import robotitle from '../Assets/robotitle.png'
import './logo.css';

const center = {
	position: "absolute",top: "-160px", left: 0, right: 0, bottom: 0, justifyContent: 'center', alignItems: 'center'
}

const RoboLogo = props => {
	return <div style={{margin:"20px", ...center}}>
		<div style={{...center, top:150}}>
			<img src={robotitle} class={"strokeme2"} alt={"ROBOTRON"}/>
		</div>
	</div>
}

export default RoboLogo